import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EVENTQ_NOTICE_DEFAULT_ICON_SRC } from './notice-default-icon';

export type EventqNoticeTone = 'info' | 'orange';

@Component({
  selector: 'eventq-notice',
  templateUrl: './notice.html',
  styleUrl: './notice.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqNotice {
  readonly message = input.required<string>();
  /** Optional; when omitted, the built-in ECAM emblem icon is used. */
  readonly iconSrc = input<string | undefined>(undefined);
  readonly tone = input<EventqNoticeTone>('orange');

  readonly resolvedIconSrc = computed(
    () => this.iconSrc() ?? EVENTQ_NOTICE_DEFAULT_ICON_SRC,
  );
}
